module.exports = __webpack_public_path__ + "img/goal-fourteen-en.1c637bd1.png";